export const AUTHENTICATE_USER="/api/auth/authenticateUser"
export const AUTHORIZE_USER="/api/auth/authorizeUser"
export const AUTH_REFRESH="/api/auth/refresh"
export const AUTH_PRIVILEGES="/api/auth/privileges"
export const LOGOUT="/api/auth/logout"
export const RECENT_ACTIVITY="/api/task/activity"
export const DASHBOARD="/api/user/dashboard"
export const CURRENT_USER="/api/user/logged-in-user"
export const USER="/api/user/user"
export const USERS="/api/user/users"
export const USERSDATA="/api/user/data"
export const TASK_DATA="/api/task/data"
export const TASK="/api/task/task"
export const TASK_STATUS="/api/task/status"
export const TASK_FILES="/api/task/files"
export const TASK_COMMENT="/api/task/comment"
export const TASK_UPDATE="/api/task/update"
export const TASKS="/api/task/tasks"
export const TASKS_BOARD="/api/task/tasks-board"
export const ROLES="/api/role/roles"
export const UPLOAD_IMG="/api/user/doc"
export const OWNER_DASHBOARD="/api/owner/dashboard"
export const ORGANISATIONS="/api/owner/organisation/organisations"
export const ORGANISATION="/api/owner/organisation/organisation"
export const ORGANISATION_STATUSES="/api/owner/organisation/statuses"
export const SUBSCRIPTION_UPGRADE="/api/owner/subscription/upgrade"
export const ORG_ROLES="/api/org/role/roles"
export const ORG_ROLE="/api/org/role/role"
export const ORG_ROLE_PRIVILEGES="/api/org/role/privileges"
export const ORG_USERS="/api/org/user/users"
export const ORG_USER="/api/org/user/user"
export const ORG_MASTERS_PROGRAMS="/api/org/masters/programs"
export const ORG_MASTERS_PRIORITIES="/api/org/masters/priorities"
export const ORG_MASTERS_PRIORITY_SUGGESTIONS="/api/org/masters/priorities/suggestions"
export const ORG_MASTERS_STATUSES="/api/org/masters/statuses"
export const ORG_MASTERS_STATUS_SUGGESTIONS="/api/org/masters/statuses/suggestions"
export const ORG_MASTERS_STATUS_FROM_SUGGESTION="/api/org/masters/statuses/from-suggestion"
export const ORG_MASTERS_WORKFLOWS="/api/org/masters/workflow/workflows"
export const ORG_MASTERS_WORKFLOW="/api/org/masters/workflow/workflow"
export const ORG_MASTERS_WORKFLOW_APPROVE="/api/org/masters/workflow/workflow/approve"
export const ORG_MASTERS_WORKFLOW_REJECT="/api/org/masters/workflow/workflow/reject"
export const ORG_MASTERS_WORKFLOW_SET_ACTIVE="/api/org/masters/workflow/workflow/set-active"
export const ORG_MASTERS_WORKFLOW_ROLES="/api/org/masters/workflow/roles"
export const ORG_MASTERS_WORKFLOW_MAKER_CHECKER_TEMPLATE="/api/org/masters/workflow/maker-checker-template"
export const ORG_EXTERNAL_CONTACTS="/api/org/external-updates/contacts"
export const ORG_EXTERNAL_TEMPLATES="/api/org/external-updates/templates"
export const ORG_EXTERNAL_VENDOR_TEMPLATES="/api/org/external-updates/vendor-templates"
export const ORG_EXTERNAL_PARAM_FIELDS="/api/org/external-updates/param-fields"
export const ORG_EXTERNAL_SUBSCRIBERS="/api/org/external-updates/subscribers"
